import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { SiteContentProvider } from "./contexts/SiteContent";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { PriceList } from "./pages/PriceList";
import { Contact } from "./pages/Contact";
import { About } from "./pages/About";
import { Privacy } from "./pages/Privacy";
import { AdminPanel } from "./pages/AdminPanel";
import { Blog } from "./pages/Blog";
import { BlogPost } from "./pages/BlogPost";
import { Booking } from "./pages/Booking";
import { FAQ } from "./pages/FAQ";
import { Packages } from "./pages/Packages";
import { Promotions } from "./pages/Promotions";
import { WeightLoss } from "./pages/WeightLoss";
import { Prizes } from "./pages/Prizes";
import { CancellationRefund } from "./pages/CancellationRefund";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <SiteContentProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin panel - no navbar/footer */}
              <Route path="/admin" element={<AdminPanel />} />
              {/* Public pages */}
              <Route path="*" element={
                <>
                  <Navbar />
                  <main>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/prices" element={<PriceList />} />
                      <Route path="/faqs" element={<FAQ />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:id" element={<BlogPost />} />
                      <Route path="/booking" element={<Booking />} />
                      <Route path="/packages" element={<Packages />} />
                      <Route path="/promotions" element={<Promotions />} />
                      <Route path="/weight-loss" element={<WeightLoss />} />
                      <Route path="/prizes" element={<Prizes />} />
                      <Route path="/cancellation-refund-policy" element={<CancellationRefund />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </div>
      </SiteContentProvider>
    </HelmetProvider>
  );
}

export default App;
